import { gql } from '@apollo/client'

export const UPDATE_FORM_TEMPLATE_STATUS_MUTATION = gql`
  mutation UpdateFormTemplateStatus(
    $id: String!
    $input: UpdateFormTemplateInput!
  ) {
    updateFormTemplate(id: $id, input: $input) {
      id
      status
    }
  }
`

export const FORM_SUBMISSIONS_QUERY = gql`
  query FormSubmissions(
    $filters: FormSubmissionFilters
    $pagination: PaginationInput
  ) {
    formSubmissions(filters: $filters, pagination: $pagination) {
      edges {
        id
        formTemplateId
        formTemplate {
          id
          title
        }
        submissionData
        status
        submissionType
        submittedAt
        archivedAt
        submittingUser {
          id
          firstName
          lastName
          email
        }
      }
      pageInfo {
        totalCount
        hasNextPage
        cursor
      }
    }
  }
`

export const FORM_TEMPLATES_QUERY = gql`
  query FormTemplates {
    formTemplates {
      id
      title
      description
      status
      createdAt
      submissionCount
      createdBy {
        firstName
        lastName
      }
    }
  }
`
